import { Injectable } from '@angular/core'
import { PvsRequestFactoryService } from './pvs-request-factory.service'
import { ApiPath } from '../../config/global-const'
import { SharedService } from './shared.service'

export enum EInfoFormType {
    CUSTOMER_INFO = 'customer-info',
    APPOINTMENT_INFO = 'appointment-info',
    SELL_GIFT_CARD_INFO = 'sell-gift-card-info',
}
export interface IInfoForm {
    id?: number
    type: EInfoFormType
    typeDisplay?: string
    status?: string
    customer?: any
    phoneNumber?: string
    firstName?: string
    lastName?: string
    dateInString?: string
    timeInString?: string
    note?: string
    skippedAt?: string
    respondedAt?: string
    updatedAt?: string
    createdAt?: string
}
@Injectable({
    providedIn: 'root',
})
export class InfoFormService {
    constructor(private requestService: PvsRequestFactoryService, private sharedService: SharedService) {}
    public create(data: IInfoForm) {
        const url = this.requestService.createUrl(ApiPath.INFO_FORM.PATH)
        return this.requestService.requestPost(url, data)
    }
    public update(id: number, data: IInfoForm) {
        const url = this.requestService.createUrl(ApiPath.INFO_FORM.DETAIL_PATH, {
            id: id,
        })
        return this.requestService.requestPut(url, data)
    }
    public skip(id: number) {
        const url = this.requestService.createUrl(ApiPath.INFO_FORM.SKIP, {
            id: id,
        })
        return this.requestService.requestPost(url)
    }
    public getList(queryParams) {
        const url = this.requestService.createUrl(ApiPath.INFO_FORM.PATH)
        return this.requestService.requestGet(url, queryParams)
    }
}
